// DashboardIndex.jsx
import { useSelector } from "react-redux";
import MerchantProfile from "../../../pages/merchant/dashboard/Profile";
import UserProfile from "../../../pages/merchant/dashboard/userDashboard/UserProfile";

const DashboardIndex = () => {
  const role = useSelector((state) => state.merchant?.user?.role);

  if (role === "merchant") return <MerchantProfile />;
  if (role === "user") return <UserProfile />;

  return null; // or loader
};

export default DashboardIndex;
